import React, { useContext } from 'react';
import styled from 'styled-components';
import { Border, Breakpoints, Color, Grid, Shadow, Type } from '../app/StyleGuide';
import { ModalBackground } from './ModalElements';

const OverlayContainer = styled.div`
  position: relative;
  background-color: ${Color.white};
  box-shadow: ${Shadow.regular};
  margin: 0 auto;
  padding: 0;
  border-radius: 0;
  width: auto;
  height: 100vh;
  height: 100svh;
  overflow-y: auto;
  color: ${Type.Color.dark};
  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    border-radius: ${Border.radius};
    height: auto;
    max-height: 95vh;
  }
`;

const Background = styled(ModalBackground)`
  padding: 0;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    padding: 0 ${Grid._5};
  }
`;

const CloseButton = styled.button`
  position: absolute;
  padding: ${Grid._3};
  top: ${Grid._2};
  right: ${Grid._3};
  background: none;
  border: 0;
  font-size: ${Type.Scale._3};
  color: ${Type.Color.medium};
`;

const OverlayContext = React.createContext<{ handleDismiss: (() => void) | undefined }>({ handleDismiss: undefined });

export default function Overlay({
  dismissHandler,
  children,
  disableBackgroundDismiss = false,
}: React.ComponentProps<typeof ModalBackground>) {
  return (
    <Background
      data-qa-hook="overlay-background"
      id="overlay-background"
      dismissHandler={dismissHandler}
      disableBackgroundDismiss={disableBackgroundDismiss}
    >
      <OverlayContext.Provider value={{ handleDismiss: dismissHandler }}>
        <OverlayContainer role="alertdialog">{children}</OverlayContainer>
      </OverlayContext.Provider>
    </Background>
  );
}

const OverlayCloseButton = (props: React.ComponentPropsWithoutRef<typeof CloseButton>) => {
  const { handleDismiss } = useContext(OverlayContext);

  return (
    <CloseButton aria-label="Close" onClick={handleDismiss} {...props}>
      <i className="fas fa-times" />
    </CloseButton>
  );
};

Overlay.CloseButton = OverlayCloseButton;
